import React, { type ReactNode, createContext, useContext, useState, useCallback } from "react";
import type { Id } from "../types";

interface DrawerCtx {
  contactId: Id | null;
  open: (id: Id) => void;
  close: () => void;
}

const DrawerContext = createContext<DrawerCtx>({ contactId: null, open: () => {}, close: () => {} });

export function DrawerProvider({ children }: { children: ReactNode }) {
  const [contactId, setContactId] = useState<Id | null>(null);
  const open = useCallback((id: Id) => setContactId(id), []);
  const close = useCallback(() => setContactId(null), []);
  return <DrawerContext.Provider value={{ contactId, open, close }}>{children}</DrawerContext.Provider>;
}

export function useDrawer() {
  return useContext(DrawerContext);
}
